<template>
    <div class="container-fluid px-3 px-md-0 px-lg-0 px-xl-0 video-list-container">
        <div class="row">
            <div class="col-md-6 col-lg-4 col-xl-4" 
                v-for="(videoInfo, index) in displayedVideoInfoList" 
                :key="`${videoInfo.title}_${index}`"
            >
                <VideoLibraryItem
                    :videoId="`${videoInfo.videoType}_${videoInfo.videoNum}`"
                    :videoSrc="videoInfo.videoSrc"
                    :videoType="videoInfo.videoType"
                    :videoTitle="videoInfo.title"
                    :videoTextDescription="videoInfo.content"
                    :videoThumbnail="videoInfo.thumbnail"
                    :selectedVideoPlayingId="selectedVideoPlayingId"
                    :isVideoPlayerPlayer="isVideoPlayerPlayer"
                    :isMP4Video="videoInfo.isMP4Player"
                    :videoIdForCopyVideoSrcUrl="videoIdForCopyVideoSrcUrl"
                    @receive-videoId-forCopyVideoUrl="setVideoIdForCopyVideoSourceUrl"
                    :tagColors="tagColors"
                />
            </div>
            <div 
                v-if="displayedVideoInfoList.length === 0"
                class="w-100 empty-video-list-container"
            >
                <span>There aren't any videos available for&nbsp;<b>"{{ `${videoSearchQuery}` }}"</b></span>
            </div>
        </div>
        <div v-if="(displayedVideoInfoList.length > 0) && (totalRows > videosPerPage)" class="d-flex flex-column justify-content-center align-items-center my-4">
            <div class="mb-3 page-number-text">
                <span><b>{{ `${cummulativeVideosDisplayed}` }}</b> videos from <b>{{ `${totalRows}` }}</b> total videos</span>
            </div>
            <b-pagination
                class="ml-0"
                id="video-library"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="videosPerPage"
                align="center"
                @page-click="pageClicked"
            />
        </div>
    </div>
</template>

<script>
    import { BPagination } from "bootstrap-vue";
    import VideoLibraryItem from "./video-library-item.vue";
    export default {
        props: {
            videoSearchQuery: {
                type: String,
                default: null,
            },
            videoInfoList: {
                type: Array,
                default: [],
            },
            isMP4Player: {
                type: Boolean,
                default: false,
            },
            scrollToElementId: {
                type: String,
                default: null,
            },
            tagColors: {
                type: Object,
                default: () => ({}),
            },
            searchByVideoType: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            BPagination,
            VideoLibraryItem,
        },
        data() {
            return {
                selectedVideoPlayingId: null,
                videoIdForCopyVideoSrcUrl: null,
                currentPage: 1,
                cummulativeVideosDisplayed: 0,
            };
        },
        computed: {
            displayedVideoInfoList() {
                const updatedVideoInfoList = this.videoSearchQuery === null || this.videoSearchQuery === ""
                                                ? this.videoInfoList 
                                                : this.videoInfoList.filter(({ title }) => title.trim().toLowerCase().includes(this.videoSearchQuery.trim().toLowerCase()));

                if(this.currentPage < this.numberOfPages) {
                    this.cummulativeVideosDisplayed = this.currentPage * this.videosPerPage;
                }
                else {
                    this.cummulativeVideosDisplayed = this.totalRows;
                }

                return updatedVideoInfoList.slice(
                    (this.currentPage - 1) * this.videosPerPage,
                    this.currentPage * this.videosPerPage
                );
            },
            totalRows() {
                return this.videoSearchQuery === null || this.videoSearchQuery === ""
                            ? this.videoInfoList.length 
                            : this.videoInfoList.filter(({ title, videoType }) => (videoType === this.videoSearchQuery) || (title.trim().toLowerCase().includes(this.videoSearchQuery.trim().toLowerCase()))).length;
            },
            numberOfPages() {
                const mainNumber = Math.floor( this.totalRows / this.videosPerPage );
                const remainder = this.totalRows % this.videosPerPage;
                return remainder === 0 ? mainNumber : mainNumber+1;
            },
            videosPerPage() {
                return this.$vuetify.breakpoint.sm ? 8 : 9;
            }
        },
        methods: {
            pageClicked() {
                document
				    .getElementById(this.scrollToElementId)
				    .scrollIntoView({ behavior: "smooth", block: "start" });
            },
            isVideoPlayerPlayer(selectedVideoId) {
                this.selectedVideoPlayingId = selectedVideoId;
            },
            setVideoIdForCopyVideoSourceUrl(videoId) {
                this.videoIdForCopyVideoSrcUrl = videoId;
            },
        },
        watch: {
            videoSearchQuery() {
                this.currentPage = 1;
            },
        },
    }
</script>

<style scope>
    .video-list-container {
        min-width: 370px;
    }
    .page-number-text {
        font-size: 24px;
    }
    .empty-video-list-container {
        font-size: 28px;
        height: auto;
        text-align: center;
        word-wrap: break-word;
    }
</style>